import React, { useContext } from 'react';
import { Typography, makeStyles} from '@ellucian/react-design-system/core';
import { spacing50, spacing40, spacing90, fontSizeSmall } from '@ellucian/react-design-system/core/styles/tokens';
import { FormattedMessage, useIntl } from 'react-intl';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';
import MFAContext from './MFAContext';

const useStyles = makeStyles((theme) => ({
    title: { 
        marginBottom: spacing40
    },
    root: {
        paddingTop: spacing40,
    },
    container: {
        paddingLeft: spacing90,
    },
    wrapper: {
        textAlign: 'justify'
    },
    qrCode: {
        marginBottom: spacing40,
        marginLeft: spacing50
    },
    accessCode: {
        marginBottom: spacing40
    },
    otpSecret: {
    },
    [theme.breakpoints.down('sm')]: {
        root: {
            marginBottom: spacing40,
        },
        container: {
            paddingLeft: '0',
        },
        wrapper : {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        qrCode: {
            marginLeft: '0'
        },
        otpSecret: {
            fontSize: fontSizeSmall,
        }
    },
}));

const QRCode = () => {
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const { qrCodeInfo } = useContext(MFAContext);

    return (
        <div className={classes.root} role="contentinfo">
            <div className={classes.container}>
                <div className={classes.wrapper}>
                    <Typography className={classes.title}>
                        <HtmlFormattedMessage descriptor={{ id: 'applicationRetrievalQrCodeInstructions' }} />
                    </Typography>

                    <div className={classes.qrCode}>
                        {qrCodeInfo?.qrCodeDataUrl ? <img src={qrCodeInfo?.qrCodeDataUrl} alt={formatMessage({ id: 'invalidQRCodeImgAltText' })}/> : ''}
                    </div>

                    <Typography className={classes.accessCode}>
                        <FormattedMessage id="applicationRetrievalAlternateCodeInstructions" />
                    </Typography>

                    <Typography className={classes.otpSecret}>
                        <strong>{qrCodeInfo?.otpSecret ? `${qrCodeInfo?.otpSecret}` : ''}</strong>
                    </Typography>
                </div>
            </div>           
        </div>
    );
};

export default QRCode;